document.addEventListener("DOMContentLoaded", function () {
  const $wrapper = $(".facets-wrapper");
  const $container = $(".product-grid-container #product-grid");
  const $mobileOpen = $(".mobile-facets__open");
  const $appliedFilters = $('.applied_filters')

  $(".vertical-filter-button").click(function () {
    $(this).toggleClass("active");
    $wrapper.toggle();
    $container
      .toggleClass("grid--3-col-desktop")
      .toggleClass("grid--4-col-desktop");
  });

  $mobileOpen.click(function () {
    $wrapper.addClass("active");
    $(this).addClass("isopen");
  });

  $(".drawer_fitler_header .close_filter , .btn-show-results").click(
    function () {
      $wrapper.removeClass("active");
      $mobileOpen.removeClass("isopen");
    }
  );

  $(document).click(function (event) {
    var target = $(event.target);
    if (
      !target.closest(".facets-wrapper").length &&
      !target.closest(".mobile-facets__open").length &&
      $mobileOpen.hasClass("isopen")
    ) {
      $wrapper.removeClass("active");
    }
  });

  $('.results-filter-header').click(function() {
    if ($appliedFilters.hasClass('active')) {
        $appliedFilters.removeClass('active')
    } else {
        $appliedFilters.addClass('active')
    }
  })

});
